// InventoryServices/InventoryAPI/AddRelatedProduct.js
import { axiosInstance } from "../../../Services";

export const AddRelatedProduct = async (id, data) => {
  try {
    const res = await axiosInstance.post(
      `/rsform/inventories/relate/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// Get Related Designs
export const getRelatedDesigns = async (id) => {
  try {
    const res = await axiosInstance.get(
      `/rsform/inventories/${id}/related`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};